import "./AccreditationSpecialCircumstances.scss";
import AcademicProgramSelector from "../expediente/components/academicProgramSelector";
import Badge from "../_common/components/Badge";
import ButtonSpinner from "../_common/components/buttons/buttonSpinner/buttonSpinner";
import Loading from "../_common/components/loading/Loading";
import {AppPage} from "../_common/components/app-page";
import {
    ACE_STATUS_PENDING,
    ACE_STATUS_REVIEW,
    ACE_STATUS_VALIDATED,
} from "../constants";
import {CF, E, FR} from "../_common/layout";
import { Fragment, h } from "preact";
import {FormFieldTextArea, UploadFile} from "../_common/forms/components/components";
import { useSelector } from "react-redux";
import { isMobileAgent } from "../_common/common";
import { t } from "../_i18n";
import { useHistory } from "react-router";
import { useState, useEffect } from "preact/hooks";
import AlertBox from "../_common/components/AlertBox/AlertBox";
import {connect} from "react-redux";
import { Form as FinalForm } from 'react-final-form'
import { getAceData, uploadAceData, updateAceData, downloadAceData } from "../_rx/documentosAce/actions";

const statusBadgeTextDic = {
    [ACE_STATUS_PENDING]: t("Pendiente"),
    [ACE_STATUS_REVIEW]: t("Revisar"),
    [ACE_STATUS_VALIDATED]: t("Validado"),
};
const statusBadgeClassDic = {
    [ACE_STATUS_PENDING]: "badge-warning",
    [ACE_STATUS_REVIEW]: "badge-danger",
    [ACE_STATUS_VALIDATED]: "badge-success translucent",
};

const BadgeComponent = ({ status, extraClass }) => (
    <Badge
        className={`t-upper width-fit-content badge font-small ${extraClass} flex-align-self-end ${
            statusBadgeClassDic[status] || "d-none"
        }`}
    >
        {t(statusBadgeTextDic[status])}
    </Badge>
);

function AccreditationSpecialCircumstances({
    studentId,
    documentosAce,
    getAceData,
    uploadAceData,
    updateAceData,
    downloadAceData,
}) {
    /** Constants **/
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);

    const [initialLoading, setInitialLoading] = useState(true);

    /** Redux **/
    const finished_academic_programs = useSelector(
        (state) => state.status.student_meta.finished_academic_programs
    );

    /** State **/
    const [academicProgramSelector, setAcademicProgramSelector] =
        useState(null);
    const [academicProgramSelected, setAcademicProgramSelected] =
        useState(null);

    /** Lifecycle **/
    useEffect(() => {
        const academicProgramSelector = finished_academic_programs;

        setAcademicProgramSelected(academicProgramSelector[0]);
        setAcademicProgramSelector(academicProgramSelector);

        fetchAceDocuments(studentId, academicProgramSelector[0].id);
    }, []);

    /** Methods **/
    const handleProgramSelector = (programSelected) => {
        if (
            !programSelected ||
            programSelected.id === academicProgramSelected?.id
        ) {
            return;
        }
        setAcademicProgramSelected(programSelected);
        fetchAceDocuments(studentId, programSelected.id);
    };
    const handleSubmitFile = async (event, moreInfoValue) => {
        const uploadedFile = event.target.files[0];

        if (!uploadedFile) return;

        setFile({
            name: uploadedFile.name,
            url: URL.createObjectURL(uploadedFile),
            rawFile: uploadedFile,
            source: "local",
        });

        if (documentosAce.selected_document_id) {
            await updateAceDocument(documentosAce.selected_document_id, uploadedFile);
        } else {
            let opts = {
                file: uploadedFile,
                moreInfo: moreInfoValue,
                comments: null
            };
            await uploadAceDocument(
                studentId,
                academicProgramSelected.id,
                opts
            );
        }

        resetFile();

        await fetchAceDocuments(studentId, academicProgramSelected.id);
    };
    const handleDownloadFile = async (file) => {
        downloadAceDocument(file.id, file.name)
    }
    const resetFile = () => {
        setFile(null);
    };
    const fetchAceDocuments = async (studentId, academicProgramId) => {
        await getAceData(studentId, academicProgramId);
        setInitialLoading(false);
    };
    const uploadAceDocumentuploadAceDocument = async (studentId, academicProgramId, opts) => {
        setLoading(true);
        try {
            await uploadAceData(studentId, academicProgramId, opts);
        } finally {
            setLoading(false);
        }
    };
    const updateAceDocument = async (documentId, file) => {
        setLoading(true);
        try {
            await updateAceData(documentId, file);
        } finally {
            setLoading(false);
        }
    };
    const downloadAceDocument = async (documentId, fileName) => {
        setLoading(true);
        try {
            await downloadAceData(documentId, fileName);
        } finally {
            setLoading(false);
        }
    }
    /** Render **/
    return (
        <CF className="max-width-980 m-x2-top">
            <div className="m-top">
                {academicProgramSelector &&
                    academicProgramSelector.length > 0 && (
                        <div className="card-ACE-full-width d-flex">
                            <AcademicProgramSelector
                                academicProgramSelector={
                                    academicProgramSelector
                                }
                                fullWidth={'fullWidth'}
                                onChange={handleProgramSelector}
                            />
                            <div className="hr-divider"></div>
                            <AlertBox type="dashed">
                                <div dangerouslySetInnerHTML={{__html: t("ACE_text")}}/>
                            </AlertBox>
                            <div className="hr-divider"></div>
                            {initialLoading ? (
                                <div className="m-top">
                                    <Loading label={`${t("Cargando")}. . . `}/>
                                </div>
                            ) : (
                                <FinalForm
                                    onSubmit={() => {}}
                                    initialValues={{ data: { more_info: '' }}}
                                    render={({ handleSubmit, values }) => {
                                        return (
                                            <form onSubmit={handleSubmit} className="full-width">
                                                <div className="card-document-dashboard background-F8F8F7">
                                                    {
                                                        !isMobileAgent() ? (
                                                            <div className="row-2-el documents-header">
                                                                <h5>Documentos: </h5>
                                                                { documentosAce.status_id &&
                                                                    <h5>Estado: <BadgeComponent extraClass={documentosAce.status_id && 'm-l'} status={documentosAce.status_id}/></h5>
                                                                }
                                                            </div>
                                                        ) : (
                                                            <div className="row-1-el">
                                                                { documentosAce.status_id &&
                                                                    <h5>
                                                                        Estado:
                                                                        <BadgeComponent
                                                                            extraClass={documentosAce.status_id && 'm-l'}
                                                                            status={documentosAce.status_id}
                                                                        />
                                                                    </h5>
                                                                }
                                                                <h5>Documentos:</h5>

                                                            </div>
                                                        )
                                                    }
                                                    {documentosAce?.documents?.length > 0 ? (
                                                        <Fragment>
                                                            {documentosAce.documents
                                                                .filter(doc => !doc.selected_document_id || doc.selected_document_id)
                                                                .map((aceDocument) => (
                                                                    <Fragment>
                                                                        <div className="row-1-el m-bottom-half"
                                                                             key={aceDocument.id || aceDocument.name}>
                                                                            <a className="ace-document font-color-149BAB t-underline"
                                                                               onClick={() => handleDownloadFile(aceDocument)}>{aceDocument.name}</a>
                                                                            {documentosAce.discount_name &&
                                                                                <Fragment>
                                                                                    <div
                                                                                        class="d-flex flex-baseline-y m-top-x2">
                                                                                        <span><strong>Descuento aplicado: </strong></span>
                                                                                        <Badge
                                                                                            className="width-fit-content badge-dark-green font-small font-color-white m-l">
                                                                                            {t(`${documentosAce.discount_name}`)}
                                                                                        </Badge>
                                                                                    </div>
                                                                                </Fragment>
                                                                            }
                                                                        </div>
                                                                    </Fragment>
                                                                ))}
                                                            {documentosAce.comments &&
                                                                <AlertBox type="warning" className="m-top-x2 m-bottom">
                                                                    {documentosAce.comments}
                                                                </AlertBox>
                                                            }
                                                        </Fragment>

                                                    ) : (
                                                        <div className="row-1-el">
                                                            <em> No hay documentos a validar. </em>
                                                        </div>
                                                    )}
                                                </div>

                                                <FR>
                                                    <E className='full-width m-top'>
                                                        <Fragment>
                                                            {documentosAce.more_info &&
                                                                <Fragment>
                                                                    <h5 className="m-top">{t('Información adicional del estudiante')}:</h5>
                                                                    <AlertBox type="warning" class="m-top">
                                                                        <span>{documentosAce.more_info}</span>
                                                                    </AlertBox>
                                                                </Fragment>
                                                            }
                                                            {!documentosAce.selected_document_id &&
                                                                <div class="m-top-x2">
                                                                    <FormFieldTextArea
                                                                        name='data.more_info'
                                                                        required={true}
                                                                        specificError={t('Añade un mensaje detallado tus necesidades')}
                                                                        label={t('Enviar Mensaje:')}
                                                                        placeholder={t('¿Necesitas información adicional?')}
                                                                    />
                                                                </div>
                                                            }
                                                        </Fragment>
                                                    </E>
                                                </FR>

                                                <div className="hr-divider m-bottom"></div>

                                                <div className={`t-upper ${loading ? "" : "m-top"}`}>
                                                    {loading ? (
                                                        <ButtonSpinner showSpinner={loading} className="button-spinner">
                                                            {t("Subir archivo")}
                                                        </ButtonSpinner>
                                                    ) : (
                                                        documentosAce.status_id !== 3 && (
                                                            <UploadFile
                                                                classNameButton="btn btn-primary m-top t-upper"
                                                                accept="image/jpeg,image/png,application/pdf"
                                                                onChange={(file) => handleSubmitFile(file, values.data.more_info)}
                                                            >
                                                                {documentosAce.selected_document_id ? t("Actualizar archivo") : t("Subir archivo")}
                                                            </UploadFile>
                                                        )
                                                    )}
                                                </div>
                                            </form>
                                        );
                                    }}
                                />
                            )}
                        </div>
                    )}
            </div>
        </CF>
    );
}

AccreditationSpecialCircumstances = connect(
    ({ auth, documentos_ace }) => ({
        studentId: auth.loggedUser.id,
        documentosAce: documentos_ace.documentAce,
    }),
    { getAceData, uploadAceData, updateAceData, downloadAceData }
)(AccreditationSpecialCircumstances);

export default () => {
    const history = useHistory();
    return (
        <AppPage
            name="ACE"
            title={t("ACE")}
            back={history.goBack}
            class="max-width-980"
        >
            <AccreditationSpecialCircumstances />
        </AppPage>
    );
};
